const transactions = '/transactions';

export const getAllTransactions = transactions;
export const getTransactionById = (transactionId: number) => `transactions/${transactionId}`;
export const exportAllTransactions = `${transactions}/download`
export const notifySapByTransactionId = (transactionId: number) => `${transactions}/${transactionId}/sap-notified`;
export const notifySapManually = `${transactions}/manual-notification`;
export const updateTransactionStatus = (transactionId: number) => `${transactions}/${transactionId}/status`;
